import {fsa, fsaError, fsaPayload, fsaPayloadByKeys} from './helpers'

import {getJsonFromResponse} from '../utils'

import {getProductSet} from '../api/product'
import {isBadResponse} from '../api/statusCodes'
import {productIsOk} from '../store/product'
import * as pdp from '../store/productDetailPage'
import * as track from '../track/product'

import {displayFeaturedReviews, featuredReviewsNotOk} from './reviews'
import services from '../config/services'

export const DISPLAY_PRODUCT = 'DISPLAY_PRODUCT'
export const PRODUCT_OK = 'PRODUCT_OK'
export const PRODUCT_NOT_OK = 'PRODUCT_NOT_OK'
export const DISPLAY_CATEGORY = 'DISPLAY_CATEGORY'
export const CATEGORY_OK = 'CATEGORY_OK'
export const CATEGORY_NOT_OK = 'CATEGORY_NOT_OK'
export const RESET_TO_INITIAL_STATE = 'RESET_TO_INITIAL_STATE'
export const CLOSE = 'close add to look dropdown'
export const OPEN = 'open add to look dropdown'

const CATEGORY_PATH = '/shop/display-categories/'

export const productOk = (data) => ({
  type: PRODUCT_OK,
  data,
})

export const productNotOk = (data) => ({
  type: PRODUCT_NOT_OK,
  data,
})

export const categoryOk = (data) => ({
  type: CATEGORY_OK,
  data,
})

export const categoryNotOk = (data) => ({
  type: CATEGORY_NOT_OK,
  data,
})

export const displayProductAction = (data) => ({
  type: DISPLAY_PRODUCT,
  data,
})

export const displayCategoryAction = (data) => ({
  type: DISPLAY_CATEGORY,
  data,
})

export const GET_RECOMMENDED_ITEMS = 'get recommended items'
export const getRecommendedItems = fsa(GET_RECOMMENDED_ITEMS)

export const GET_RECOMMENDED_ITEMS_FAILURE = 'get recommended items failure'
export const getRecommendedItemsFailure = fsaError(GET_RECOMMENDED_ITEMS_FAILURE)

export const GET_RECOMMENDED_ITEMS_PENDING = 'get recommended items is pending'
export const getRecommendedItemsPending = fsa(GET_RECOMMENDED_ITEMS_PENDING)

export const GET_RECOMMENDED_ITEMS_SUCCESS = 'get recommended items succeeded'
export const getRecommendedItemsSuccess = fsaPayload(GET_RECOMMENDED_ITEMS_SUCCESS)

export const DISPLAY_PRODUCT_DETAILS = 'display product details'
export const displayProductDetails = fsaPayloadByKeys(DISPLAY_PRODUCT_DETAILS, ['slug', 'origin'])

const fetchFromService = (uri) =>
  fetch(`${services.PRODUCT_SERVICE_URL}${uri}`)
    // BUG: Determine whether this triggering the unrecoverable errors on the PDP.
    // TODO: Investigate best practice.
    .catch((error) => {
      throw new Error(error)
    })
    .then(getJsonFromResponse)

const resolveFetchReviews = () => (dispatch, getState) => {
  dispatch(displayFeaturedReviews(pdp.productId(getState())))
  return Promise.resolve(true)
}

const addProduct = (slug) => async (dispatch, getState) => {
  if (productIsOk(getState(), slug)) {
    return dispatch(resolveFetchReviews())
  }

  try {
    const {json, status} = await getProductSet(slug)
    if (isBadResponse(status)) {
      throw new Error('Unable to fetch product.')
    }

    dispatch(productOk(json))
    dispatch(displayFeaturedReviews(json.id))
    return json
  } catch {
    dispatch(productNotOk(slug))
    dispatch(featuredReviewsNotOk(slug))
    return null
  }
}

const addCategory = async (dispatch, state, slug) => {
  const rawJson = await fetchFromService(`${CATEGORY_PATH}${slug}`)
  dispatch(rawJson ? categoryOk(rawJson) : categoryNotOk(slug))
  return rawJson // XXX: Needed for subsequent analytics call...
}

export const displayProduct = (slug, origin) => async (dispatch) => {
  dispatch(displayProductAction(slug))
  const json = await dispatch(addProduct(slug))
  if (json) {
    track.viewedProduct(json, origin)
  }
}

const displayCategory = (dispatch, getState, slug) => {
  dispatch(displayCategoryAction(slug))
  return addCategory(dispatch, getState(), slug)
}

export const addProductThunk = (slug) => (dispatch) => dispatch(addProduct(slug))
export const displayCategoryThunk = (slug) => (dispatch, getState) =>
  displayCategory(dispatch, getState, slug)

export function resetToInitialState() {
  return {
    type: RESET_TO_INITIAL_STATE,
  }
}
